import React, { useState } from 'react';
import { API_URL } from '../config';

interface UploadFormProps {
  userId: string;
  onSuccess: () => void;
}

export default function UploadForm({ userId, onSuccess }: UploadFormProps) {
  const [file, setFile] = useState<File | null>(null);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!file || !title) {
      setError('Arquivo e título são obrigatórios');
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('title', title);
      formData.append('description', description);
      formData.append('userId', userId);

      const response = await fetch(`${API_URL}/api/documents/upload`, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Erro ao enviar documento');
      }

      setSuccess('Documento enviado com sucesso!');
      setFile(null);
      setTitle('');
      setDescription('');
      // Aguardar um pouco para garantir que o banco foi atualizado
      setTimeout(() => {
        onSuccess();
      }, 500);
    } catch (err: any) {
      setError(err.message || 'Erro ao enviar documento');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="upload-form">
      <div className="form-group">
        <label htmlFor="title">Título do Documento *</label>
        <input
          id="title"
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Ex: RG, Comprovante de Endereço, Contrato"
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="description">Descrição (opcional)</label>
        <textarea
          id="description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Adicar informações sobre o documento"
          rows={3}
        />
      </div>

      <div className="form-group">
        <label htmlFor="file">Arquivo *</label>
        <input
          id="file"
          type="file"
          onChange={(e) => setFile(e.target.files?.[0] || null)}
          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.txt"
          required
        />
        {file && <p className="file-info">Arquivo selecionado: {file.name} ({(file.size / 1024).toFixed(2)} KB)</p>}
      </div>

      {error && <div className="alert alert-error">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      <button type="submit" disabled={loading} className="btn btn-primary">
        {loading ? 'Enviando...' : 'Enviar Documento'}
      </button>
    </form>
  );
}
